import { render, staticRenderFns } from "./mdd.vue?vue&type=template&id=5a0f139f&scoped=true&"
import script from "./mdd.vue?vue&type=script&lang=js&"
export * from "./mdd.vue?vue&type=script&lang=js&"
import style0 from "./mdd.vue?vue&type=style&index=0&id=5a0f139f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f139f",
  null
  
)

export default component.exports